/**
 *
 */
export const minus = {
    paths: [{ d: 'M2 7.75A.75.75 0 0 1 2.75 7h10a.75.75 0 0 1 0 1.5h-10A.75.75 0 0 1 2 7.75Z' }],
    viewBox: '0 0 16 16',
};
//# sourceMappingURL=minus.js.map